<template>
    <el-container>
        <el-header>
               每日一句
        </el-header>
        <el-main>
            <div class="title-content">
            <el-card :body-style="{ padding: '0px' }">
                    <img :src="iciba.picture2" class="image"/>
                    <div style="padding: 14px;">
                        <el-row>
                            <el-col :span="24">
                        <span>{{iciba.content}}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <span>{{iciba.note}}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-link :href="iciba.tts" type="success" target="_blank">点击收听英文</el-link>
                        </el-row>
                    </div>
                </el-card>
            </div>

        </el-main>
        <el-main>
            <el-divider content-position="center">我是分割线</el-divider>
            <el-row>
                <el-col :span="24">
                <div class="block"><el-avatar :size="50" :src="userinfo.avatar"></el-avatar></div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <span>{{userinfo.getupTime}}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-badge :is-dot="!(button.getupdisabled&&button.sleepdisabled)" class="item">
                        <el-button  style="margin-left: 0px;" type="success" @click="doGetup" v-loading.fullscreen.lock="fullscreenLoading" :disabled="button.getupdisabled&&button.sleepdisabled">{{button.content}}</el-button>
                    </el-badge>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <div class="block">
                    <el-timeline>
                        <el-timeline-item :timestamp="dailypunch.getupTime"  placement="bottom" :hide-timestamp="true">
                            {{dailypunch.getupContent}}
                        </el-timeline-item>
                        <el-timeline-item :timestamp="dailypunch.sleepTime" placement="bottom" :hide-timestamp="true">
                            {{dailypunch.sleepContent}}
                        </el-timeline-item>
                    </el-timeline>
                    </div>
                </el-col>
            </el-row>
        </el-main>
        <!--el-footer>
            footer
        </el-footer-->
    </el-container>


</template>

<script>

    let globalId = '';
    export default {
        data() {
            return {
              //  id : this.$route.params.id,
                //radio1: '未起床',
                isExpiredDate: false,
                currentDate: new Date(),
                fullscreenLoading: false,
                button:{
                    getupdisabled: true,
                    sleepdisabled: true,
                    content: '起床打卡'
                },
                getDay: '',
                iciba: {
                    getupState:'1',
                    note:'',
                    content: '',
                    picture2: '',
                    tts: ''

                },
                userinfo:{
                    userId: '',
                    name: '',
                    gender: '',
                    qrCode: '',
                    avatar: '',
                    url: '',
                    jsapi_ticket: '',
                    timestamp: '',
                    signature: '',
                    appid : ''
                },
                dailypunch:{
                    userId: '',
                    punchDate: '',
                    getupTime: '',
                    sleepTime: '',
                    getupContent: '还未起床',
                    sleepContent: '还未睡觉'
                }
            }
        },
        methods: {
            onSubmit() {
                debugger
                console.log(this.iciba);
            }// 请求openid的方法，需要后端写法
           ,getopenid_data(code) {
                let apiurl = '/api/robot/daily/getuserinfo/'+code
                this.$http.get(apiurl).then((response) => {
                    console.log(response.data)
                    this.userinfo.userId = response.data.userId
                    this.userinfo.name = response.data.name
                    this.userinfo.gender = response.data.gender
                    this.userinfo.qrCode = response.data.qrCode
                    this.userinfo.avatar = response.data.avatar
                }).catch(error => {
                    alert(error)
                })
            },
            prepareDailyPunch(){
                this.button.getupdisabled = false;
                this.button.sleepdisabled = false;
                if(this.dailypunch.getupTime!=null && this.dailypunch.getupTime !=''){
                    //alert(this.format(this.dailypunch.getupTime, "yyyy-MM-dd HH:mm:ss"))
                    this.dailypunch.getupTime = this.format(new Date(this.dailypunch.getupTime), "yyyy-MM-dd HH:mm:ss");

                    this.dailypunch.getupContent = '起床'+'['+this.dailypunch.getupTime+']';
                    this.button.content='睡觉打卡'
                    this.button.getupdisabled = true
                }

                if(this.dailypunch.sleepTime!=null && this.dailypunch.sleepTime !=''){
                    this.dailypunch.sleepTime = this.format(new Date(this.dailypunch.sleepTime), "yyyy-MM-dd HH:mm:ss");

                    this.dailypunch.sleepContent = '睡觉'+'['+this.dailypunch.sleepTime+']';
                    this.button.content='不需要打卡'
                    this.button.sleepdisabled = true;
                }

               // alert('this.isExpiredDate:'+this.isExpiredDate)
                if(this.isExpiredDate) {
                    this.button.getupdisabled = true;
                    this.button.sleepdisabled = true;
                    this.button.content = '打卡时间已过'
                    //that.button.disabled = false
                    //that.dailypunch.getupContent = '还未起床'
                }


            }
            ,
            format(date, fmt) {
                let o = {
                    "M+": date.getMonth() + 1, //月份
                    "d+": date.getDate(), //日
                    "H+": date.getHours(), //小时
                    "m+": date.getMinutes(), //分
                    "s+": date.getSeconds(), //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    "S": date.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (let k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            }

            ,doGetup(){
                let getupUrl = '/api/robot/daily/getuppunch/'+this.userinfo.userId
                if(this.button.getupdisabled){
                    getupUrl = '/api/robot/daily/sleeppunch/'+this.userinfo.userId
                }
               // alert(getupUrl)
                this.fullscreenLoading = true;
                this.$http.get(getupUrl).then((response) => {

                    this.dailypunch.userId = response.data.userId;
                    this.dailypunch.punchDate = response.data.punchDate;
                    this.dailypunch.getupTime = response.data.getupTime;
                    this.dailypunch.sleepTime = response.data.sleepTime;

                    this.prepareDailyPunch();

                    this.fullscreenLoading = false;
                }).catch(error => {
                    alert(error)
                })
            },queryPunch(that,userid)
            {

                let jappid = this.userinfo.appid
                let jtimestamp = this.userinfo.timestamp;
                let jnonceStr = this.userinfo.nonceStr;
                let jsignature = this.userinfo.signature;
                wx.config({
                    beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: jappid, // 必填，企业微信的corpID
                    timestamp: jtimestamp, // 必填，生成签名的时间戳
                    nonceStr: jnonceStr, // 必填，生成签名的随机串
                    signature: jsignature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
                    jsApiList: ['hideAllNonBaseMenuItem'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
                });

                wx.ready(function () {

                    wx.hideAllNonBaseMenuItem();
                    wx.hideOptionMenu();
                    //alert('ready')

                    wx.hideMenuItems({
                        menuList: ["menuItem:share:appMessage",
                            "menuItem:share:wechat",
                            "menuItem:favorite",
                            "menuItem:openWithSafar",
                            "menuItem:share:email",
                            "menuItem:refresh","menuItem:setFont", "menuItem:copyUrl"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                    });

                })

              //  alert('this:'+this.userinfo.userid+':'+userid)
                let queryUrl = '/api/robot/daily/querypunch/'+userid+'/'+that.getDay;
                that.$http.get(queryUrl).then((response) => {
                   // console.log("###:L"+response)
                   // console.log("111###222:"+response.data+":"+typeof (response.data))
                    if(response.data==''||response.data==null||response.data == undefined) {

                        this.prepareDailyPunch();


                    }else{
                        this.dailypunch.userId = response.data.userId;
                        this.dailypunch.punchDate = response.data.punchDate;
                        this.dailypunch.getupTime = response.data.getupTime;
                        this.dailypunch.sleepTime = response.data.sleepTime;


                        this.prepareDailyPunch();


                    }

                    this.fullscreenLoading = false;
                }).catch(error => {
                    alert(error)
                })

            }
            ,getUrlParam (name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
                let url = window.location.href.split('#')[0]
                let search = url.split('?')[1]
                if (search) {
                    var r = search.substr(0).match(reg)
                    if (r !== null) return unescape(r[2])
                    return null
                } else {
                    return null
                }
            }
        }
        , created () {

           // console.log(navigator.userAgent)
           // alert(navigator.userAgent)
            this.fullscreenLoading = true;
           // let id = this.$route.params.id;
            let getDay = this.$route.params.getDay;


            let currentTime = this.format(new Date(), "yyyy-MM-dd");
            //alert('currentTime:'+currentTime+':getDay:'+getDay)
            if(getDay!=currentTime){
                this.isExpiredDate = true
               // alert('this.isExpiredDate:'+this.isExpiredDate)
            }
          //  alert('getDay:'+getDay)
            if(getDay == undefined){
                getDay = '';
            }
            this.getDay = getDay;
            var code = this.getUrlParam('code')
            var local = window.location.href

           //   code = 'OwFns0r3nLbTVD_2HcYVBXuBj6denBaLu8knpXbZxAs'
            let sessionUserinfo = window.localStorage.getItem("userinfo")
            let hasData = false

            //alert('sessionUserinfo:'+sessionUserinfo);
            if(sessionUserinfo!=null&&sessionUserinfo!=''){

                this.userinfo =  JSON.parse(sessionUserinfo);
                hasData = true;
            }
            let that = this

            //alert('hasData:'+hasData+":"+this.userinfo.userId);
            if(!hasData){


                if (code == null || code == '') {

                    console.log('https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww61845d6b2e7a4ad2&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=state#wechat_redirect')
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww61845d6b2e7a4ad2&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=state#wechat_redirect'
                }
                else {
                    this.code = code
                    this.$ewechatTools.getEWechatUserInfo(that,code,getDay,this.queryPunch)
                }

            }else{
               // alert('getEWechatSign:');
                this.$ewechatTools.getEWechatSign(that,getDay,this.queryPunch)
            }


                let apiurl = '/api/robot/daily/getupdailycard/'+getDay


                this.$http.get(apiurl).then((response) => {
                    console.log(response.data)
                    this.iciba.note = response.data.note;
                    this.iciba.content = response.data.content;
                    this.iciba.picture2 = response.data.picture2;
                    this.iciba.tts = response.data.tts;
                    // this.getopenid_data(code)


                })

             //   window.addEventListener('beforeunload', this.goBack, false)

                //this.getopenid_data(code)

        },mounted() {
            document.title='每日一句';

          //  if (window.history && window.history.pushState) {
          //      history.pushState(null, null, document.URL);
          //      window.addEventListener('popstate', this.goBack, false);
          //  }






        },destroyed() {
           // window.removeEventListener('popstate', this.goBack, false);
            //window.removeEventListener('beforeunload', this.goBack, false);

        }
    }

</script>

<style>
    .el-row {
        margin-bottom: 20px;
    &:last-child {
         margin-bottom: 0;
     }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }

    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }

    .title-content{
        text-align:left;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .content{
        text-align:left;
        font-size:18px;
        background: #e5e9f2;

    }

    .el-button{
        font-size:12px;
    }

    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

</style>
